import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";

export const useRouter = () => {
  const { router } = useDataRouterContext();
  return router;
};
